<template>
	<div id="app">
		<Header/>
		<Content/>
		<Footer/>
	</div>
</template>

<script>
import Header from "@/components/template/header"
import Content from "@/components/template/content"
import Footer from "@/components/template/footer"
import { VueEasyJwt } from "vue-easy-jwt"

export default {
	name: "app",
	components: { Header, Content, Footer },
	data: function() {
			return {
				jwt: new VueEasyJwt()
			}
	},
	methods: {
		validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
				this.$store.commit('toggleVisible', false)
                this.$router.push({ path: '/login' })
            } else {
				this.$store.commit('toggleVisible', true)
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
	},
	mounted() {
        this.validaLogin()
    }
}
</script>

<style>
body {
	margin: 0;
}

#app {
	position: relative;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	height: 100vh;

	display: grid;

	grid-template-rows: 56px 1fr 40px;
	grid-template-columns: 1fr;
	grid-template-areas:
		"header"
		"content"
		"footer";

}
</style>
